
export const LangLabel = {
    "LABEL_ADD": "Tambah",
    "LABEL_EDIT": "Edit",
    "LABEL_DELETE": "Hapus",
    "LABEL_SAVE": "Simpan",
    "LABEL_UPDATE": "Simpan",
    "LABEL_CANCEL": "Batal",
    "LABEL_PENCARIAN": "Kata Kunci Pencarian",
    "LABEL_SEARCH": "Cari",
    "LABEL_SHOW": "Tampilkan",
    "LABEL_KEYWORD": "Kata Kunci",
    "LABEL_ACTION": "Aksi",
    "LABEL_FIRST": "Awal",
    "LABEL_PREVIOUS": "Sebelumnya",
    "LABEL_NEXT": "Selanjutnya",
    "LABEL_LAST": "Akhir",
    "LABEL_LIST_ALL": "-Semua-",
    "LABEL_DATE_PLACEHOLDER": "dd/mm/yy",
    "LABEL_PDF_TOOLTIP": "Simpan sebagai PDF",
    "LABEL_XLS_TOOLTIP": "Simpan sebagai XLS",
    "LABEL_MODULE_INDEX": "Direktori Modul ",
    "LABEL_NUMBERING": "No.",
    "LABEL_RECAP": "Rekap",
    "LABEL_TOTAL": "Total",
    "LABEL_DATA_NOT_FOUND": "Data Tidak Tersedia!",
    "LABEL_PAGINATION_COUNT": "Jumlah Data: ",
    "LABEL_PDF": "PDF",
    "LABEL_XLS": "XLS",
    "LABEL_DELETE_SUCCESS": "Data berhasil dihapus.",
    "LABEL_DELETE_CONFIRMATION": "Apakah Anda yakin akan menghapus data ini?",
    "LABEL_EDIT_ON_DUPLICATION": "Data baru sudah tersedia di database sebelumnya!",
    "LABEL_EDIT_ON_SUCCESS": "Data berhasil diperbaharui.",
    "LABEL_ADD_ON_DUPLICATION": "Data sudah tersedia di database!",
    "LABEL_ADD_ON_SUCCESS": "Data berhasil disimpan.",
    "LABEL_ACCESS_DENIED": "Anda tidak memiliki hak akses!",
    "LABEL_ADD_DENIED": "Anda tidak diperkenankan melakukan penambahan data!",
    "LABEL_EDIT_DENIED": "Anda tidak diperkenankan melakukan perubahan terhadap data ini!",
    "LABEL_PROCESS_CANCELED": "Proses dibatalkan.",
    "LABEL_PERUBAHAN_DATA": "Perubahan Data ",
    "LABEL_DELETE_DENIED": "Maaf Anda tidak diperkenankan melakukan penghapusan data, silakan hubungi admin!",
    "LABEL_FILE_TYPE_UPLOAD_NOT_ALLOWED": "Proses dibatalkan, Anda hanya diperkenankan mengupload file %s pada kolom %s",
    "LABEL_PAGE_ADD": "Penambahan Data %s",
    "LABEL_PAGE_EDIT": "Perubahan Data %s",
    "LABEL_PAGE_DATALIST": "Daftar %s",
    "LABEL_MAIN_MENU": "MENU UTAMA",
    "LABEL_DASHBOARD": "Dashboard",
    "LABEL_SUBMIT": "Kirim",
    "LABEL_INFORMATION": "Informasi!",
    "LABEL_CONFIRMATION": "Korfirmasi!",
    "LABEL_WARNING": "Perhatian!",
    "LABEL_ERROR": "Error!",
    "LABEL_WELCOME_TO_LOGIN": "Selamat datang, silakan Login!",
    "LABEL_FORGOT_PASSWORD": "Lupa Password?",
    "LABEL_FORGOT_PASSWORD_DESCRIPTION": "Silakan masukan alamat email Anda yang terdaftar di sistem!",
    "LABEL_LOGIN": "Login Aplikasi",
    "LABEL_LOGOUT": "Logout",
    "LABEL_REGISTER": "Register",
    "LABEL_EMAIL": "Email",
    "LABEL_USERNAME": "Username",
    "LABEL_PASSWORD": "Password",
    "LABEL_DONT_HAVE_ACCOUNT": "Tidak punya akun?",


    "MSG_ERROR_LOGIN": "Username dan Password tidak cocok, silakan coba lagi!",
    "MSG_PASSWORD_CHANGED_SUCCESS": "Password Anda berhasil diperbaharui.",
    "MSG_PASSWORD_CHANGED_DOESNOT_MATCH": "Password Baru dan Konfirmasi Password Baru harus sama!",
    "MSG_PASSWORD_DOESNOT_MATCH": "Password dan Konfirmasi Password harus sama!",
    "MSG_CURRENT_PASSWORD_DIDNOT_MATCH": "Maaf, password saat ini tidak sesuai.",
    "MSG_EMAIL_NOT_FOUND": "Maaf, email tidak terdaftar di sistem.",
    "MSG_REQUIRED": "Silakan diisi!",
    "MSG_REQUIRED_EMAIL": "Alamat email tidak sesuai!",
    "MSG_REQUIRED_PHONE": "Nomor HP tidak sesuai!",
    "MSG_PASS_MIN_LENGTH_1": "Panjang password minimal ",
    "MSG_PASS_MIN_LENGTH_2": "karakter!",
    "MSG_NOT_VALID": "Tidak valid!"
}